<template>
    <MyAccountPage/>
</template>

<script>
// @ is an alias to /src
import MyAccountPage from '@/components/MyAccountPage.vue'

export default {
  name: 'MyAccountView',
  components: {
    MyAccountPage
  }
}
</script>